<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div class="overflow-hidden rounded main-height bg-white">
      <div class="main-height overflow-auto">
        <!-- 切替 -->
        <div class="bg-white rounded mr-5">
          <div class="flex items-center py-1 rounded mx-5 ">
            <div v-for="tab in typeList" 
              :key="tab.id" 
              class="w-full text-center mx-1 cursor-pointer"
              :class="[type == tab.id ? 'bg-light-blue-700' : 'hover:bg-gray-400', 'bg-gray-300 rounded-md w-full py-2 text-sm font-medium text-white']" 
              @click="tabChange(tab)"
            >
              {{ tab.name }}
            </div>
          </div>
        </div>

        <div class="flex justify-end sticky top-0 bg-white">
          <div class="py-1 px-2 mt-auto cursor-pointer" @click="add()">
            <Icon
              iconName="PlusCircle"
              class="w-8 h-8 text-blue-800"
            />
          </div>
        </div>
        <!-- 日報 -->
        <table v-if="type==1" class="overflow-auto main table-auto mb-3">
          <thead class="main sticky top-10 bg-white">
            <tr v-if="list && list.length" class="border border-gray-200">
              <th v-for="(c, index) in columns" :key="index" scope="col" class="pl-4 pr-1 py-3 text-xs font-medium text-gray-500 tracking-wider bg-colu text-left" :class="c.class">
                {{c.title}}
              </th>
            </tr>
          </thead>

          <tr v-for="(row, i) in list" :key="i" class="border border-gray-200 tracking-wider hover-color">

            <!-- ユーザー -->
            <td class="pl-3 pr-1 py-0.5 text-gray-500">
              <!-- 新規 -->
              <select
                v-if="!row.id"
                name="userName"
                v-model="row.userName"
                class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                @change="edit(row, $event)"
              >
                <option
                  v-for="(c, ci) in userList" :key="'user'+ci"
                  :value="c.userName"
                  class="bg-white">
                  {{ c.userName }}
                </option>
              </select>

              <!-- 登録済み -->
              <div v-else class="text-sm">
                {{ row.userName }}
              </div>
            </td>

            <!-- ルームID -->
            <td class="pl-3 pr-1 py-0.5 text-gray-500">
              <input
                type="number"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-32 py-1.5"
                v-model="row.roomId"
                @input="edit(row)"
              />
            </td>

            <!-- トークン -->
            <td class="pl-3 pr-1 py-0.5 text-gray-500">
              <input
                type="text"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 text-xs w-60 py-2.5" 
                v-model="row.apiToken"
                @input="edit(row)"
              />
            </td>

            <td class="px-1 py-0.5 text-center text-sm font-medium border-gray">
              <div class="flex justify-center">
                <PrimaryButton text="保存" size="normal" class="w-16 p-1" :disabled="!row.editFlg" :class="!row.editFlg?'bg-gray-300':'bg-blue-800'" @click="save(row)" />
                <PrimaryButton text="削除" size="normal" class="ml-2 w-16 p-1 bg-red-700" @click="remove(row, i)" />
              </div>
            </td>
          </tr>
        </table>

        <!-- 勉強会 -->
        <div v-else>
          <div class="flex items-end">
            <div>
              <div class="font-bold text-xs text-gray-700">ルームID</div>
              <input
                type="number"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-32 py-1.5"
                v-model="list.roomId"
                @input="edit2()"
              />
            </div>  
            <div class="mx-1">
              <div class="font-bold text-xs text-gray-700">APIトークン</div>
                <input
                  type="text"
                  class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 text-xs w-60 py-2.5" 
                  v-model="list.apiToken"
                  @input="edit2()"
                />
            </div>
            <div class="flex justify-center ml-3">
              <PrimaryButton text="更新" size="normal" class="" :disabled="!list.editFlg" :class="!list.editFlg?'bg-gray-300':'bg-blue-800'" @click="saveRoomId()" />
            </div>
          </div>

          <div class="mt-8 w-full">
            <div class="font-bold text-xs text-gray-700 mb-3">感想文をチャットに送信する人</div>
            <div v-for="(row, i) in list.user" :key="'type2'+i" class="flex mb-3">
              <!-- 新規 -->
              <WmsSuggestInput
                v-if="!row.id"
                name="user"
                class="min-w-300px"
                :selectionItems="userList"
                displayField="userName"
                v-model="row.userName"
                @selected="staffSelected($event, row)"
              >
              </WmsSuggestInput>

              <!-- 登録済み -->
              <div v-else class="min-w-300px self-center">
                {{ row.userName }}
              </div>

              <!-- ボタン -->
              <PrimaryButton text="保存" size="normal" class="ml-5 w-16 px-1 py-2" :disabled="!row.editFlg" :class="!row.editFlg?'bg-gray-300':'bg-blue-800'" @click="save(row)" />
              <PrimaryButton text="削除" size="normal" class="ml-2 w-16 p-1 bg-red-700" @click="remove(row, i)" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && (!list || !list.length)" class="flex justify-center items-center text-gray-500 font-bold nothing">
        <p class="text-gray-400 font-bold">対象データがありません</p>
      </div>
      <div class="text-transparent">{{reload}}</div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Icon from '@components/Icon.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as backend from '@libs/backend'

const TOKEN = '12e6247b22aa5826875a69997587ea01'

export default {
  components: {
    Modal,
    PrimaryButton,
    Icon,
    WmsSuggestInput
  },

  props: ['open'],

  data() {
    return {
      // ローディング
      loading: false,
      // タブ切り替え
      typeList: [
        { id: 1, name: '日報' },
        { id: 2, name: '勉強会' }
      ],
      type: 1,
      // カラム
      columns: [
        {title: '対象のユーザー'},
        {title: 'ルームID'},
        {title: 'APIトークン'},
        {title: ''},
      ],
      // リスト
      list: [
        { editFlg: false, userName: '', roomId: null }
      ],
      // ユーザーリスト
      userList: [],
      reload: 0
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    /**
     * 初期にリセット
     */
    closed() {
      // リスト
      this.list = [
        { editFlg: false, userName: '', roomId: null }
      ]
      // ユーザーリスト
      this.userList = []
      this.loading = false
      this.$emit('close')
    },

    /**
     * リスト取得
     */
    async getData() {
      this.loading = true
      this.list = []
      this.userList = []
      let res

      // 日報
      if (this.type == 1) {
        res = await backend.getData('evaluation/getDailyReportChat')
        if (res.data.data) {
          this.list = res.data.data.chat
          for (let i = 0; i < res.data.data.userList.length; i++) {
            const u = res.data.data.userList[i]
            const name = (utils.deleteKana(u.userName))
            let flg = false
            for (let j = 0; j < this.list.length; j++) {
              const l = this.list[j]
              if (utils.deleteSpace(l.userName) == utils.deleteSpace(name)) {
                flg = true
              }
            }
            if (!flg) {
              this.userList.push({ userName: name })
            }
          }
        }
      // 勉強会
      } else {
        res = await backend.getData('evaluation/getStudyChat')
        if (res.data.data) {
          this.userList = res.data.data.userList

          const chat = res.data.data.chat
          if (chat.length) {
            this.list.roomId = chat[0].roomId
            this.list.apiToken = chat[0].apiToken
            this.list.user = chat
          } else {
            this.list.roomId = 394563652
            this.list.apiToken = TOKEN
          }
        }
        this.add()
      }

      this.loading = false
    },

    /**
     * 編集イベント
     * @param row 編集対象データ
     */
    edit(row) {
      row.editFlg = true
      this.reload++
    },

    /**
     * 編集イベント
     */
    edit2() {
      this.list.editFlg = true
      this.reload++
    },

    /**
     * 保存
     * @param row 対象データ
     */
    async save(row) {
      if (!row.userName) {
        await dialogs.showErrorDialog('対象のユーザー', '未選択です。対象のユーザーを選択してください。')
        return
      }
      if (this.type == 1 && !row.roomId) {
        await dialogs.showErrorDialog('ルームID', '未入力です。ルームIDを入力してください。')
        return
      } else if (this.type == 2 && (!this.list.roomId || !this.list.apiToken)) {
        await dialogs.showErrorDialog('ルームID、APIトークン', 'ルームID、APIトークンを入力してください。')
        return
      }

      if (this.type == 1) {
        // ダブりがないかチェック
        const double = this.list.filter((l) => {
          return utils.deleteSpace(l.userName) == utils.deleteSpace(row.userName)
        })
        if (double.length > 1) {
          await dialogs.showErrorDialog('重複のため保存不可', 'すでに同じユーザーのデータがあります。')
          return
        }
        // 同じルームIDがないかチェック
        const room = this.list.filter((r) => {
          return r.roomId == row.roomId
        })
        if (room.length > 1) {
          const dia = await dialogs.showConfirmDialog('ルームID重複あり', 'すでに同じルームIDが登録されていますが、よろしいでしょうか？')
          if (dia != 'YES') {
            return
          }
        }
      } else {
        // 社員の名前とユーザーIDが同じか確認
        if (!row.userId) {
          await dialogs.showErrorDialog('再度ユーザーを選択してください', '正しいユーザー情報が取得できませんでした。\r\n再度ユーザーを選択してください。')
          return
        } else {
          const name = this.userList.find((u) => {
            return u.userId == row.userId
          })
          if (name && name.userName) {
            if (name.userName != row.userName) {
              await dialogs.showErrorDialog('再度ユーザーを選択してください', '正しいユーザー情報が取得できませんでした。\r\n再度ユーザーを選択してください。')
              return
            }
          } else {
            await dialogs.showErrorDialog('再度ユーザーを選択してください', '正しいユーザー情報が取得できませんでした。\r\n再度ユーザーを選択してください。')
            return
          }
        }
        // ダブりがないかチェック
        const double = this.list.user.filter((l) => {
          return l.userId == row.userId
        })
        if (double.length > 1) {
          await dialogs.showErrorDialog('重複のため保存不可', 'すでに同じユーザーのデータがあります。')
          return
        }
      }
      const saveData = utils.clone(row)
      delete saveData.editFlg
      saveData.type = this.type
      saveData.insertUser = this.$store.getters.user.id
      if (this.type == 1) {
        saveData.userName = utils.deleteSpace(row.userName)
      } else {
        saveData.roomId = this.list.roomId
        saveData.apiToken = this.list.apiToken
      }
      const res = await backend.postData('chatworkData/saveChat', saveData)
      if (res.status==200) {
        await dialogs.showSuccessDialog('保存しました')
        row.editFlg = false
        this.reload++
        // ログ登録
        let newFlag = true
        if (row.id) {
          newFlag = false
        }
        let typeName = this.typeList.find((t) => {
          return t.id == this.type
        }).name
        logManager.recordingByRegist(this, newFlag, typeName + 'Chatwork', `${row.userName}のChatworkルームID`)
        // 再描画
        this.getData()
      }
    },

    /**
     * 勉強会のルームID保存
     */
    async saveRoomId() {
      if (!this.list.roomId) {
        await dialogs.showErrorDialog('ルームID', '未入力です。ルームIDを入力してください。')
        return
      }
      if (!this.list.apiToken) {
        await dialogs.showErrorDialog('APIトークン', '未入力です。APIトークンを入力してください。')
        return
      }
      const res = await backend.postData('evaluation/updateChatRoomId', { roomId: this.list.roomId, apiToken: this.list.apiToken, type: this.type, user: this.$store.getters.user.id })
      if (res.status==200) {
        await dialogs.showSuccessDialog('保存しました')
        this.list.editFlg = false
        this.reload++
        logManager.recordingByRegist(this, false, '勉強会Chatwork', `勉強会のChatworkルームID`)
        this.getData()
      }
    },

    /**
     * 削除
     * @param row 対象データ
     * @param i インデックス
     */
    async remove(row, i) {
      if (row.id) {
        let typeName = this.typeList.find((t) => {
          return t.id == this.type
        }).name
        let msg = `${row.userName}さんのChatworkルームIDを削除します。`
        if (this.type == 2) {
          msg = `${row.userName}さんを削除します。`
        }
        const res = await dialogs.showConfirmDialog('削除してよろしいですか？', msg)
        if (res != 'YES') {
          return
        }
        await backend.deleteData('chatworkData/deleteChat', row, false)
        await dialogs.showSuccessDialog('削除しました')
        // ログ登録
        logManager.recording(this, logManager.Loglevel.INFO, typeName + 'Chatwork', '削除', `${row.userName}さんを削除しました。`)
      }
      this.list.splice(i, 1)
      this.getData()
    },

    /**
     * 追加ボタン
     */
    add() {
      const row = { editFlg: false, userName: '', roomId: null, apiToken: TOKEN }
      if (this.type == 1) {
        this.list.push(row)
      } else {
        if (!this.list.user) {
          this.list.user = []
        }
        this.list.user.push(row)
      }
    },

    /**
     * タブ切り替え
     */
    tabChange(tab) {
      this.type = tab.id
      this.getData()
    },

    /**
     * 社員選択イベント
     */
    staffSelected(e, row) {
      row.userId = e.userId
      row.editFlg = true
      this.reload++
    },
  }
}
</script>
<style scoped>
.main-height {
  height: 85vh;
}

.h-95vh {
  height: 95vh;
}

.h-93vh {
  height: 93vh;
}

.main {
  min-width: 700px;
}

.b-top {
  border-top: 1px solid rgb(228, 227, 227);
}

.bg-colu {
  background: #edecf7;
}

.hover-color:hover {
  background: #edecf7 !important;
}

.title {
  color: #7f7caf;
}
</style>